import React from 'react';
import { View } from 'react-native';

import { Text } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { PrimaryButton } from '../../design/components';

import { createPickListDetailStyles } from './PickListDetail.styles';

// "Change to tub N" prompt that pauses picking until the picker confirms.
const PickListTubSwitchOverlay = ({
	banner,
	overlayTopStyle,
	tubIndex,
	onAcknowledge,
}) => {
	const styles = useThemedStyles(createPickListDetailStyles);

	return (
		<View
			style={[styles.overlay, styles.tubSwitchOverlay, overlayTopStyle]}
			accessibilityViewIsModal={true}
			importantForAccessibility="yes"
		>
			{banner}
			<View style={styles.tubSwitchBody}>
				<View style={styles.tubSwitchContent}>
					<Text style={styles.tubSwitchStatus}>Picking paused</Text>
					<Text
						style={styles.tubSwitchTitle}
						accessibilityRole="alert"
						accessibilityLabel={`Change to tub ${tubIndex}. Move the next products into tub ${tubIndex} before continuing.`}
						accessibilityLiveRegion="assertive"
					>
					Change to tub {tubIndex}
					</Text>
					<Text style={styles.tubSwitchText}>
					Move the next products into tub {tubIndex} before you continue.
					</Text>
					<PrimaryButton
						label="Tub changed"
						onPress={onAcknowledge}
						accessibilityHint="Continues picking in the new tub"
					/>
				</View>
			</View>
		</View>
	);
};

export default PickListTubSwitchOverlay;
